import {RootIcon} from "@ui/icons/RootIcon";

import styles from "./styles.module.scss";

export const Timer = ({time}) => {
  const safeTime = Number(time) || 0;
  const seconds = Math.floor((safeTime / 1000) % 60);
  const minutes = Math.floor((safeTime / 1000 / 60) % 60);
  const formattedTime = `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;

  return (
    <div className={styles.timerWrapper}>
      <RootIcon id={"clock"} />
      <div
        className={styles.timer}
        style={{
          color: `${
            safeTime <= 60000 && safeTime !== 0
              ? "var(--red)"
              : "rgba(138, 138, 138, 1)"
          }`,
        }}
      >
        {formattedTime}
      </div>
    </div>
  );
};
